import React from 'react'
import CheckoutController from '../../components/controllers/checkout/CheckoutController';

const CheckoutPage = () => {
  return <CheckoutController />
}

export default CheckoutPage
